console.log('product-affiliate');

(async function () {
    app_affiliate_load = {
        init: async function () {
            _this = this;
            affUrl = '';
            affVariants = [];
            affSelected = null;

            setTimeout(function () {
                let affVariantsJson = document.querySelector('#productVariantList')?.innerHTML;
                if(affVariantsJson) {
                    affVariants = JSON.parse(affVariantsJson);
                }
                console.log('timeout');
                _this._AffiliateListenVariantChange();
                _this._AffiliateGetSelectedVariant();
            }, 1000);

        },
        _AffiliateListenVariantChange: function () {
            console.log('change');
            _this._AffiliateListenUrlStatus();
        },
        _AffiliateListenUrlStatus: function () {
            console.log('status');
            _this._overwritePushstate();
            window.addEventListener('locationchange', () => {
                _this._AffiliateGetSelectedVariant();
            });
        },
        _AffiliateGetSelectedVariant: function () {
            const currentUrl = document.URL;
            console.log('selected: ', currentUrl);

            if (currentUrl !== affUrl) {
                const currentUrl = document.URL;
                const url = new URL(currentUrl);
                var vid = url.searchParams.get('variant');
                if(!vid && affVariants && affVariants.length > 0) vid = affVariants[0].id;
                affSelected = vid;
                affUrl = currentUrl;
            }

            _this._AffiliateSetButton();
        },
        _AffiliateSetButton: function () {
            var variantData = null;
            for(v in affVariants) {
                if(affVariants[v].id == affSelected) variantData = affVariants[v].affiliate;
            }

            console.log('setButton: ', variantData);

            if(document.querySelector('#ProductSubmitButton-affiliate')) {
                document.querySelector('#ProductSubmitButton-affiliate').href = variantData.affiliate_link;
                document.querySelector('#ProductSubmitButton-affiliate span').innerHTML = 'Compre em ' + variantData.affiliate_name;
            }
        },
        _overwritePushstate: function () {

            const oldPushState = history.pushState;
            history.pushState = function pushState() {
                const ret = oldPushState.apply(this, arguments);
                window.dispatchEvent(new Event('pushstate'));
                window.dispatchEvent(new Event('locationchange'));
                return ret;
            };

            const oldReplaceState = history.replaceState;
            history.replaceState = function replaceState() {
                const ret = oldReplaceState.apply(this, arguments);
                window.dispatchEvent(new Event('replacestate'));
                window.dispatchEvent(new Event('locationchange'));
                return ret;
            };

            window.addEventListener('popstate', () => {
                window.dispatchEvent(new Event('locationchange'));
            });
        },

    };
    await app_affiliate_load.init();

})();